export const authUrl = 'https://'+process.env.REACT_APP_DOMAIN+'/api/login'
export const signupUrl = 'https://'+process.env.REACT_APP_DOMAIN+'/api/signup'
export const loginUrl = 'https://'+process.env.REACT_APP_DOMAIN+'/login'